"use client";

// 전체화면 모달/오버레이 전용 포털 — document.body에 직접 붙여 렌더링한다.
// `.web`이 컨테이너 쿼리용으로 `container-type: inline-size`를 쓰는데, 이 속성은 부수효과로
// 그 안의 position:fixed 자손들의 containing block을 뷰포트가 아니라 `.web` 자신으로 바꿔버린다
// (CSS Containment 스펙 — contain:layout 부작용과 동일). 모바일 동적 뷰포트(주소창 접힘/펼침)
// 등으로 `.web`의 100vh 박스가 실제 보이는 화면과 어긋나는 순간, 배경 콘텐츠가 모달과 겹쳐 보이는
// 버그가 생긴다. Portal로 `.web` 트리 밖(body)에 렌더링하면 이 문제 자체가 원천적으로 없어진다.
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export function Portal({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  if (!mounted) return null;
  return createPortal(children, document.body);
}
